var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option"},[(_vm.isToggleStyle)?_c('div',{staticClass:"letter",class:{
      activate: _vm.isActivate,
      success: _vm.isDone && _vm.answer === _vm.option,
      error: _vm.isActivate && _vm.isDone && _vm.option !== _vm.answer
    }},[(_vm.isDone && _vm.answer === _vm.option)?_c('span',[_vm._v("对")]):(_vm.isActivate && _vm.isDone && _vm.answer !== _vm.option)?_c('span',[_vm._v("错")]):_c('span',[_vm._v("-")])]):_c('div',{staticClass:"letter",class:{
      activate: _vm.isActivate,
      success: _vm.isDone && _vm.answer === _vm.option,
      error: _vm.isActivate && _vm.isDone && _vm.option !== _vm.answer
    }},[_vm._v("\n    "+_vm._s(_vm.numberToLetter(_vm.index))+"\n  ")]),(_vm.isImage)?_c('div',{staticClass:"text"},[_c('img',{attrs:{"src":_vm.option,"alt":""}})]):_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.option)}})])}
var staticRenderFns = []

export { render, staticRenderFns }